export default "__VITE_ASSET__58b34825__"